import { Content, Header, HeaderLabel, InfoCard, Page } from '@backstage/core-components';
import { AMLCIFormContainer } from './AMLCIFormContainer';

export const AMLCIPage = () => {
  return (
    <Page themeId="home">
      <Header title="Azure Machine Learning Compute Instance" subtitle="AML CI Request">
        <HeaderLabel label="Owner" value="Orion Infra Team" />
        <HeaderLabel label="Lifecycle" value="Alpha" />
      </Header>
      <Content>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <InfoCard>
            <AMLCIFormContainer subscription="" resourceGroup="" amlWorkspace="" computeSize="" computeType="" />
          </InfoCard>
        </div>
      </Content>
    </Page>
  );
};
